/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_Removed_BodyInputs */



/**
* | output |
* | --- |
* | "Someone removed Wundo from the call before enough was recorded for a report. Share your notes and Wundo will write one." |
*
* @param {Meeting_Notetaker_Issue_Removed_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_removed_body = /** @type {((inputs?: Meeting_Notetaker_Issue_Removed_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Removed_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Iemand haalde Wundo uit het gesprek voor er genoeg opgenomen was voor een verslag. Deel je notities, dan maakt Wundo er een.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Quelqu'un a retiré Wundo de l'appel avant que suffisamment soit enregistré pour un compte rendu. Partagez vos notes, et Wundo en rédige un.")
	return /** @type {LocalizedString} */ ("Someone removed Wundo from the call before enough was recorded for a report. Share your notes and Wundo will write one.")
});